import { createSelector, selector } from '@/store/utils';

const selectTenant = selector((state) => state.configuration.tenant);
export const tenantSelector = createSelector(selectTenant);

const selectConsents = selector((state) => state.configuration.consents);
export const consentsSelector = createSelector(selectConsents);

const selectSalesPointConfiguration = selector(
  (state) => state.configuration.salesPointConfiguration
);
export const salesPointConfigurationSelector = createSelector(
  selectSalesPointConfiguration
);
